import React, { useState } from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import { Eye, Pencil } from "lucide-react";
import DocumentPopUp from "../DocumentPopUp";
import { usePermission } from "../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import useMobile from "../../hooks/useMobile";

const DocumentsInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const [selectedDoc, setSelectedDoc] = useState<string | null>(null);
  const [showDoc, setShowDoc] = useState(false);
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();

  const handleOpenDoc = (url?: string | null) => {
    if (!url) return;
    setSelectedDoc(url);
    setShowDoc(true);
  };

  const renderViewAction = (url?: string | null) => (
    <div className="d-flex gap-3 align-items-center justify-content-end">
      <span
        onClick={() => handleOpenDoc(url)}
        style={{
          pointerEvents: url ? "auto" : "none",
          opacity: url ? 1 : 0.5,
          cursor: url ? "pointer" : "default",
        }}
      >
        <i
          className={url ? "cursor-pointer" : ""}
          data-toggle="tooltip"
          data-placement="top"
          title="View"
        >
          <Eye />
        </i>
      </span>
    </div>
  );

  const docs = cooperative?.documents as any;
  const otherDocs: string[] = Array.isArray(docs?.otherDocumentUrl)
    ? docs.otherDocumentUrl
    : typeof docs?.otherDocumentUrl === "string" && docs.otherDocumentUrl.trim()
    ? [docs.otherDocumentUrl]
    : [];

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">Documents</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 5,
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="dashboard-card mt-3">
        <div className="table-responsive admin-table table-checkbox">
          <table className="table align-middle">
            <tbody>
              <tr>
                <td>Registration Certificate</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.regCertificateUrl)}
                </td>
              </tr>
              <tr>
                <td>By Law Document</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.lawDocumentUrl)}
                </td>
              </tr>
              <tr>
                <td>Founding Document</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.foundingDocumentUrl)}
                </td>
              </tr>
              <tr>
                <td>PAN Registration Document</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.panDocumentUrl)}
                </td>
              </tr>
              <tr>
                <td>Business Registration Document</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.businessRegistrationUrl)}
                </td>
              </tr>
              <tr>
                <td>Tax Clearance Document</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.taxClearanceUrl)}
                </td>
              </tr>
              <tr>
                <td>Board Meeting Minutes</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.meetingDocumentUrl)}
                </td>
              </tr>
              <tr>
                <td>General Meeting Minutes</td>
                <td className="sticky-action">
                  {renderViewAction(docs?.agmDocumentUrl)}
                </td>
              </tr>
              {otherDocs.length > 0 ? (
                otherDocs.map((docUrl, idx) => (
                  <tr key={`other-${idx}`}>
                    <td>
                      Other Supporting Document{" "}
                      {otherDocs.length > 1 ? idx + 1 : ""}
                    </td>
                    <td className="sticky-action">
                      {renderViewAction(docUrl)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>Other Supporting Document</td>
                  <td className="sticky-action">{renderViewAction(null)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <hr />

      <DocumentPopUp
        showDoc={showDoc}
        setShowDoc={setShowDoc}
        docs={selectedDoc || undefined}
      />
    </>
  );
};

export default DocumentsInfo;
